var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomAttribute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 13817",
    transform: "translate(1272.677 -8.823)",
    fill: "#3b5175",
    stroke: "#707070",
    d: "M0 0h21v21H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 879",
    transform: "translate(-1272.677 8.823)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1274.15.753h6.942a1.158 1.158 0 0 0 1.161-1.161V-7.35a1.158 1.158 0 0 0-1.161-1.158h-6.942a1.158 1.158 0 0 0-1.158 1.158v6.942a1.158 1.158 0 0 0 1.158 1.161Zm1.157-6.946h4.63v4.63h-4.63Zm17.364-2.315h-6.945a1.158 1.158 0 0 0-1.158 1.158v6.942a1.158 1.158 0 0 0 1.158 1.158h6.946a1.158 1.158 0 0 0 1.157-1.158V-7.35a1.158 1.158 0 0 0-1.158-1.158Zm-1.158 6.946h-4.63v-4.631h4.63Zm-10.421 13.891a1.158 1.158 0 0 0 1.158-1.158V4.226a1.158 1.158 0 0 0-1.158-1.158h-6.942a1.158 1.158 0 0 0-1.158 1.158v6.946a1.158 1.158 0 0 0 1.158 1.158Zm-5.785-6.946h4.63v4.63h-4.63Zm15.049-1.158h-2.315V6.54h-2.315v2.315h2.315v2.315h2.315V8.856h2.315V6.541h-2.315Z",
    fill: "#3b5175"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomAttribute);
export default __webpack_public_path__ + "static/media/Custom_Attribute.16881bcc26152cad3bb6a5af1f770510.svg";
export { ForwardRef as ReactComponent };